import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { TaxonomicGroup } from "@typings/entities/taxonomicGroup";

async function getTaxonomicGroupById(id: string): Promise<TaxonomicGroup> {
  const response = await apiClient.get<TaxonomicGroup>(
    apiPaths.taxonomicGroups.getById(id),
  );
  return response.data;
}

export function useGetTaxonomicGroupById(
  taxonomicGroupId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    taxonomicGroupId ? [`fetch-taxonomic-group-${taxonomicGroupId}`] : null,
    () => getTaxonomicGroupById(taxonomicGroupId!),
    options,
  );
}
